module.exports = __webpack_public_path__ + "static/the-viridescent-hunt-22f8c22a0dc8205893902fe039e8c749.png";